import { match } from 'ts-pattern';
import { HandrailType, PositionType, PostConnectionType, PostType } from '../__generated/model/index.js';
export const getDeckSectionHandrail = (leftPositionType, rightPositionType, leftX, rightX, rightPostConnectionType, handrailType, maxHandrailLength, balustradeLength)=>{
    const handrailSize = match(handrailType).with(HandrailType.FlatTimber, ()=>{
        return 100;
    }).with(HandrailType.RoundStainless, ()=>{
        return 50;
    }).with(HandrailType.SquareStainless, ()=>{
        return 50;
    }).exhaustive();
    const endOverhang = 75;
    const slope = 0;
    const leftEndX = match(leftPositionType).with(PositionType.LeftEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2 - endOverhang;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX - handrailSize / 2 - endOverhang;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX - handrailSize / 2 - endOverhang;
        }).exhaustive();
    }).with(PositionType.FlatFlatRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX;
        }).exhaustive();
    }).with(PositionType.FlatFlatObtuse, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX;
        }).exhaustive();
    }).with(PositionType.FlatFlatAcuteLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX - handrailSize / 2;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX;
        }).exhaustive();
    }).with(PositionType.FlatStairsOtherTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX - handrailSize / 2;
        }).exhaustive();
    }).with(PositionType.FlatStairsOtherBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX - handrailSize / 2;
        }).exhaustive();
    }).otherwise(()=>{
        throw new Error(`Left position type ${leftPositionType} is not supported for left end of the deck section handrail`);
    });
    const leftHandrailX = match(leftPositionType).with(PositionType.LeftEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftEndX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftEndX;
        }).exhaustive();
    }).with(PositionType.FlatFlatRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftEndX + 20;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftEndX + 35;
        }).exhaustive();
    }).with(PositionType.FlatFlatObtuse, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftEndX + 30;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftEndX + 30;
        }).exhaustive();
    }).with(PositionType.FlatFlatAcuteLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftEndX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftEndX;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX + 30;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX + 30;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2 - 10;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX + 30;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX + 30;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX + 35;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX + 35;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX + 35;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX + 35;
        }).exhaustive();
    }).with(PositionType.FlatStairsOtherTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX - handrailSize / 2;
        }).exhaustive();
    }).with(PositionType.FlatStairsOtherBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX - handrailSize / 2;
        }).exhaustive();
    }).otherwise(()=>{
        throw new Error(`Left position type ${leftPositionType} is not supported for left end of the deck section handrail`);
    });
    const rightEndX = match(rightPositionType).with(PositionType.RightEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2 + endOverhang;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX + handrailSize / 2 + endOverhang;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX + handrailSize / 2 + endOverhang;
        }).exhaustive();
    }).with(PositionType.FlatFlatRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX;
        }).exhaustive();
    }).with(PositionType.FlatFlatObtuse, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX;
        }).exhaustive();
    }).with(PositionType.FlatFlatAcuteRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX + handrailSize / 2;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX;
        }).exhaustive();
    }).with(PositionType.FlatStairsOtherTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX + handrailSize / 2;
        }).exhaustive();
    }).with(PositionType.FlatStairsOtherBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX + handrailSize / 2;
        }).exhaustive();
    }).otherwise(()=>{
        throw new Error(`Right position type ${rightPositionType} is not supported for right end of the deck section handrail`);
    });
    const rightHandrailX = match(rightPositionType).with(PositionType.RightEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightEndX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightEndX;
        }).exhaustive();
    }).with(PositionType.FlatFlatRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightEndX - 20;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightEndX - 35;
        }).exhaustive();
    }).with(PositionType.FlatFlatObtuse, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightEndX - 30;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightEndX - 30;
        }).exhaustive();
    }).with(PositionType.FlatFlatAcuteRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightEndX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightEndX;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2 + 10;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX - 20;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX - 30;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX - 30;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX - 30;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX - 35;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX - 35;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX - 35;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX - 30;
        }).exhaustive();
    }).with(PositionType.FlatStairsOtherTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX + handrailSize / 2;
        }).exhaustive();
    }).with(PositionType.FlatStairsOtherBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX + handrailSize / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX + handrailSize / 2;
        }).exhaustive();
    }).otherwise(()=>{
        throw new Error(`Right position type ${rightPositionType} is not supported for right end of the deck section handrail`);
    });
    const length = rightHandrailX - leftHandrailX;
    const height = match(handrailType).with(HandrailType.FlatTimber, ()=>{
        return 973;
    }).with(HandrailType.RoundStainless, ()=>{
        return 977;
    }).with(HandrailType.SquareStainless, ()=>{
        return 977;
    }).exhaustive();
    return {
        handrailStart: leftHandrailX,
        handrailHeight: height,
        handrailLength: length,
        leftEndX,
        leftEndHeight: height,
        rightEndX,
        rightEndHeight: height,
        slope,
        sharedRightEnd: rightPostConnectionType === PostConnectionType.Shared,
        numberOfSections: Math.floor(length / maxHandrailLength) + 1,
        balustradeLength
    };
};
export const getStairsSectionHandrail = (leftPositionType, rightPositionType, balustradeLeftX, balustradeRightX, balustradeHeight, rightPostConnectionType, handrailType, postType, posts, reversed, balustradeLength)=>{
    const handrailSize = match(handrailType).with(HandrailType.FlatTimber, ()=>{
        return 100;
    }).with(HandrailType.RoundStainless, ()=>{
        return 50;
    }).with(HandrailType.SquareStainless, ()=>{
        return 50;
    }).exhaustive();
    const stairsOverhang = 50;
    const leftPost = posts[0];
    const rightPost = posts[posts.length - 1];
    const leftSlopeCenter = match(leftPositionType).with(PositionType.StairsTopLeftEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftPost.x;
        }).exhaustive();
    }).with(PositionType.StairsBottomRightEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftPost.x;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftPost.x;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftPost.x;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftPost.x + 60;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftPost.x + 60;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftPost.x - 60;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftPost.x - 60;
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftPost.x;
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftPost.x;
        }).exhaustive();
    }).otherwise(()=>{
        throw new Error(`Left position type ${leftPositionType} is not supported for left end of stairs section handrail`);
    });
    const rightSlopeCenter = match(rightPositionType).with(PositionType.StairsTopRightEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightPost.x;
        }).exhaustive();
    }).with(PositionType.StairsBottomLeftEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightPost.x;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightPost.x;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightPost.x;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightPost.x + 60;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightPost.x + 60;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightPost.x - 60;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightPost.x - 60;
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightPost.x;
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightPost.x;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightPost.x;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightPost.x;
        }).exhaustive();
    }).otherwise(()=>{
        throw new Error(`Right position type ${rightPositionType} is not supported for right end of stairs section handrail`);
    });
    const handrailSlope = Math.atan((leftPost.y - rightPost.y) / (leftSlopeCenter - rightSlopeCenter));
    const stairsSlope = Math.atan((leftPost.y - rightPost.y) / (leftPost.x - rightPost.x));
    const leftX = reversed ? balustradeRightX : balustradeLeftX;
    const rightX = reversed ? balustradeLeftX : balustradeRightX;
    const leftEndX = match(leftPositionType).with(PositionType.StairsTopLeftEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2 - stairsOverhang;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX - handrailSize / 2 - stairsOverhang;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX - handrailSize / 2 - stairsOverhang;
        }).exhaustive();
    }).with(PositionType.StairsBottomRightEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX + handrailSize / 2 + stairsOverhang;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX + handrailSize / 2 + stairsOverhang;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX + handrailSize / 2 + stairsOverhang;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX + handrailSize / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX;
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2 - stairsOverhang / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX - handrailSize / 2 - stairsOverhang / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX - handrailSize / 2 - stairsOverhang / 2;
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX + handrailSize / 2 + stairsOverhang / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX + handrailSize / 2 + stairsOverhang / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX + handrailSize / 2 + stairsOverhang / 2;
        }).exhaustive();
    }).otherwise(()=>{
        throw new Error(`Left position type ${leftPositionType} is not supported for left end of stairs section handrail`);
    });
    const leftHandrailX = match(leftPositionType).with(PositionType.StairsTopLeftEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftEndX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftEndX;
        }).exhaustive();
    }).with(PositionType.StairsBottomRightEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftEndX;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftEndX;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftEndX + 75 * Math.cos(handrailSlope);
        }).with(HandrailType.RoundStainless, ()=>{
            return leftEndX + 30 * Math.cos(handrailSlope);
        }).with(HandrailType.SquareStainless, ()=>{
            return leftEndX + 30 * Math.cos(handrailSlope);
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftEndX - 70 * Math.cos(handrailSlope);
        }).with(HandrailType.RoundStainless, ()=>{
            return leftEndX - 30 * Math.cos(handrailSlope);
        }).with(HandrailType.SquareStainless, ()=>{
            return leftEndX - 30 * Math.cos(handrailSlope);
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftEndX + 40 * Math.cos(handrailSlope);
        }).with(HandrailType.RoundStainless, ()=>{
            return leftEndX + 50 + 40 * Math.cos(handrailSlope);
        }).with(HandrailType.SquareStainless, ()=>{
            return leftEndX + 50 + 40 * Math.cos(handrailSlope);
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftEndX - 50 - 40 * Math.cos(handrailSlope);
        }).with(HandrailType.SquareStainless, ()=>{
            return leftEndX - 50 - 40 * Math.cos(handrailSlope);
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherTopLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX - handrailSize / 2 - stairsOverhang / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX - handrailSize / 2 - stairsOverhang / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX - handrailSize / 2 - stairsOverhang / 2;
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherBottomRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return leftX + handrailSize / 2 + stairsOverhang / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return leftX + handrailSize / 2 + stairsOverhang / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return leftX + handrailSize / 2 + stairsOverhang / 2;
        }).exhaustive();
    }).otherwise(()=>{
        throw new Error(`Left position type ${leftPositionType} is not supported for left end of stairs section handrail`);
    });
    const rightEndX = match(rightPositionType).with(PositionType.StairsBottomLeftEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2 + stairsOverhang;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX + handrailSize / 2 + stairsOverhang;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX + handrailSize / 2 + stairsOverhang;
        }).exhaustive();
    }).with(PositionType.StairsTopRightEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX - handrailSize / 2 - stairsOverhang;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX - handrailSize / 2 - stairsOverhang;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX - handrailSize / 2 - stairsOverhang;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX;
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX;
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2 + stairsOverhang / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX + handrailSize / 2 + stairsOverhang / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX + handrailSize / 2 + stairsOverhang / 2;
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX - handrailSize / 2 - stairsOverhang / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX - handrailSize / 2 - stairsOverhang / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX - handrailSize / 2 - stairsOverhang / 2;
        }).exhaustive();
    }).otherwise(()=>{
        throw new Error(`Right position type ${rightPositionType} is not supported for right end of stairs section handrail`);
    });
    const rightHandrailX = match(rightPositionType).with(PositionType.StairsBottomLeftEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightEndX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightEndX;
        }).exhaustive();
    }).with(PositionType.StairsTopRightEnd, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightEndX;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightEndX;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightEndX;
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightEndX - 5 * Math.cos(handrailSlope);
        }).with(HandrailType.RoundStainless, ()=>{
            return rightEndX - 30 * Math.cos(handrailSlope);
        }).with(HandrailType.SquareStainless, ()=>{
            return rightEndX - 30 * Math.cos(handrailSlope);
        }).exhaustive();
    }).with(PositionType.FlatStairsStraightTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightEndX + 30 * Math.cos(handrailSlope);
        }).with(HandrailType.RoundStainless, ()=>{
            return rightEndX + 30 * Math.cos(handrailSlope);
        }).with(HandrailType.SquareStainless, ()=>{
            return rightEndX + 30 * Math.cos(handrailSlope);
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightEndX + 20 * Math.cos(handrailSlope);
        }).with(HandrailType.RoundStainless, ()=>{
            return rightEndX - 50 - 40 * Math.cos(handrailSlope);
        }).with(HandrailType.SquareStainless, ()=>{
            return rightEndX - 50 - 40 * Math.cos(handrailSlope);
        }).exhaustive();
    }).with(PositionType.FlatStairsCornerTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightEndX + 40 * Math.cos(handrailSlope);
        }).with(HandrailType.RoundStainless, ()=>{
            return rightEndX + 50 + 40 * Math.cos(handrailSlope);
        }).with(HandrailType.SquareStainless, ()=>{
            return rightEndX + 50 + 40 * Math.cos(handrailSlope);
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherBottomLeft, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX + handrailSize / 2 + stairsOverhang / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX + handrailSize / 2 + stairsOverhang / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX + handrailSize / 2 + stairsOverhang / 2;
        }).exhaustive();
    }).with(PositionType.StairsFlatOtherTopRight, ()=>{
        return match(handrailType).with(HandrailType.FlatTimber, ()=>{
            return rightX - handrailSize / 2 - stairsOverhang / 2;
        }).with(HandrailType.RoundStainless, ()=>{
            return rightX - handrailSize / 2 - stairsOverhang / 2;
        }).with(HandrailType.SquareStainless, ()=>{
            return rightX - handrailSize / 2 - stairsOverhang / 2;
        }).exhaustive();
    }).otherwise(()=>{
        throw new Error(`Right position type ${rightPositionType} is not supported for right end of stairs section handrail`);
    });
    const handrailLength = Math.abs(rightHandrailX - leftHandrailX) / Math.cos(handrailSlope);
    const height = match(handrailType).with(HandrailType.FlatTimber, ()=>{
        return match(postType).with(PostType.Timber, ()=>{
            return 990;
        }).with(PostType.Metal, ()=>{
            return 986;
        }).exhaustive();
    }).with(HandrailType.RoundStainless, ()=>{
        return 976;
    }).with(HandrailType.SquareStainless, ()=>{
        return 976;
    }).exhaustive();
    const highestPost = reversed ? rightPost : leftPost;
    const highestHandrailEnd = reversed ? rightHandrailX : leftHandrailX;
    const hightestPositionType = reversed ? rightPositionType : leftPositionType;
    const handrailOffsetFromPost = highestHandrailEnd - highestPost.x;
    const handrailHeight = match(hightestPositionType).with(PositionType.FlatStairsCornerTopLeft, ()=>{
        return balustradeHeight + height + 30 * Math.sin(handrailSlope);
    }).with(PositionType.FlatStairsCornerTopRight, ()=>{
        return balustradeHeight + height + 30 * Math.sin(handrailSlope);
    }).otherwise(()=>{
        return balustradeHeight + height + handrailOffsetFromPost * Math.tan(stairsSlope);
    });
    const direction = reversed ? 1 : -1;
    const leftEndOffsetFromPost = Math.abs(highestPost.x - leftEndX);
    const leftEndHeight = balustradeHeight + height + direction * leftEndOffsetFromPost * Math.tan(stairsSlope);
    const rightEndOffsetFromPost = Math.abs(highestPost.x - rightEndX);
    const rightEndHeight = balustradeHeight + height - direction * rightEndOffsetFromPost * Math.tan(stairsSlope);
    return {
        handrailStart: highestHandrailEnd,
        handrailLength,
        handrailHeight,
        leftEndX,
        leftEndHeight,
        rightEndX,
        rightEndHeight,
        slope: handrailSlope,
        sharedRightEnd: rightPostConnectionType === PostConnectionType.Shared,
        numberOfSections: 1,
        balustradeLength
    };
};

//# sourceMappingURL=handrail.js.map